import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { CalendarModule } from '@shared/modules/calendar/calendar.module';
import { AddToCartModule } from '@modules/add-to-cart/add-to-cart.module';
import { MainRoutes } from './main.routes';
import { MainComponent } from './components/main.component';
import { MapModule } from '@shared/modules/map/map.module';

@NgModule({
  imports: [
    SharedModule,
    CalendarModule,
    AddToCartModule,
    MapModule,
    RouterModule.forChild(MainRoutes),
  ],
  declarations: [
    MainComponent,
  ],
})
export class MainModule { }
